export enum MyPriceApprovalModeEnum {
    DISABLED,
    ACTIVE,
    PREVIEW ,
}
